import Shepherd from "tether-shepherd";
var ApplicationTour = {
	ShowTour() {
		
		var showedBPMTour = localStorage.getItem("showedBPMTour");

		if (showedBPMTour == null) {
			localStorage.setItem(
				"showedBPMTour",
				"true"
			)

			// Create a tour
			var shepherdTour = new Shepherd.Tour({
				defaults: {
					classes: 'shepherd-element shepherd-open shepherd-theme-dark',
					showCancelLink: true
				}
			});

			// Add "steps" to it
			shepherdTour
				.addStep(
					'Welcome',
					{
						title: "Welcome!",
						text: 'BPM lets you design flexible forms combined with powerful and controlled processes. You can integrate with other systems and monitor processes using dashboards and reports.<br/><br/>'
							+ 'Please click on "Next" for a brief tour of the product or "Exit" to exit.',
						classes: 'shepherd shepherd-open shepherd-theme-dark shepherd-transparent-text',
						buttons: [{
							text: 'Exit',
							classes: 'shepherd-button-secondary',
							action: shepherdTour.cancel
						}, {
							text: 'Next',
							action: shepherdTour.next,
							classes: 'shepherd-button-example-primary'
						}]
					});
			shepherdTour
				.addStep(
					'Profile',
					{
						title: "Profile",
						text: 'You can access your profile, personal dashboard and application help from here.',
						attachTo: {
							element: '#navbar-menu-left',
							on: 'bottom center'
						},
						classes: 'shepherd shepherd-theme-dark shepherd-transparent-text shepherd-element-attached-top shepherd-step2',
						buttons: [{
							text: 'Exit',
							classes: 'shepherd-button-secondary',
							action: shepherdTour.cancel
						}, {
							text: 'Next',
							action: shepherdTour.next,
							classes: 'shepherd-button-example-primary'
						}]
					});
			shepherdTour
				.addStep(
					'Main menu',
					{
						title: "Main menu",
						text: 'The main menu allows you to access the various parts of the application.',
						attachTo: {
							element: '#left-panel-nav',
							on: 'right'
						},
						classes: 'shepherd shepherd-open shepherd-theme-dark shepherd-transparent-text shepherd-step3',
						buttons: [{
							text: 'Back',
							classes: 'shepherd-button-secondary',
							action: shepherdTour.back
						}, {
							text: 'Done',
							action: shepherdTour.next
						}]
					});

			shepherdTour.start();
		}
	}
	,
	ShowTourForMenuOnTop() {
		// Check if we have a cookie to indicate that we showed the product tour to
		var showedBPMTour = localStorage.getItem("showedBPMTour");

		if (showedBPMTour == null) {
			localStorage.setItem(
				"showedBPMTour",
				"true"
			)
			// Create a tour
			var shepherdTour = new Shepherd.Tour({
				defaults: {
					classes: 'shepherd-element shepherd-open shepherd-theme-dark',
					showCancelLink: true
				}
			});

			// Add "steps" to it
			shepherdTour
				.addStep(
					'Welcome',
					{
						title: "Welcome!",
						text: 'BPM lets you design flexible forms combined with powerful and controlled processes. You can integrate with other systems and monitor processes using dashboards and reports.<br/><br/>'
							+ 'Please click on "Next" for a brief tour of the product or "Exit" to exit.',
						classes: 'shepherd shepherd-open shepherd-theme-dark shepherd-transparent-text',
						buttons: [{
							text: 'Exit',
							classes: 'shepherd-button-secondary',
							action: shepherdTour.cancel
						}, {
							text: 'Next',
							action: shepherdTour.next,
							classes: 'shepherd-button-example-primary'
						}]
					});
			shepherdTour
				.addStep(
					'Main menu/Profile',
					{
						title: "Main menu/Profile",
						text: 'The main menu allows you to access the various parts of the application, Also you can access your profile, personal dashboard and application help from profile menu.',
						attachTo: {
							element: '#navbar-menu-top',
							on: 'bottom'
						},
						classes: 'shepherd shepherd-theme-dark shepherd-transparent-text shepherd-element-attached-top',
						buttons: [{
							text: 'Back',
							classes: 'shepherd-button-secondary',
							action: shepherdTour.back
						}, {
							text: 'Done',
							action: shepherdTour.next
						}]
					});

			shepherdTour.start();
		}
	}
}

export default ApplicationTour;